import { render, staticRenderFns } from "./ocrDialog.vue?vue&type=template&id=4d68b278&"
import script from "./ocrDialog.vue?vue&type=script&lang=js&"
export * from "./ocrDialog.vue?vue&type=script&lang=js&"
import style0 from "./ocrDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d68b278')) {
      api.createRecord('4d68b278', component.options)
    } else {
      api.reload('4d68b278', component.options)
    }
    module.hot.accept("./ocrDialog.vue?vue&type=template&id=4d68b278&", function () {
      api.rerender('4d68b278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/ocrDialog.vue"
export default component.exports